<template>
  <div id="user-sidebar-card">
    <div class="max-w-sm w-full lg:max-w-full justify-center px-6">
      <div
        class="border-r border-b border-l border-gray-400  lg:border-t lg:border-gray-400 rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal bg-gray-card-speakol">
        <div class="flex items-center">
          <img class="w-10 h-10 rounded-full mr-5" :src="avatarUrl" alt="Avatar of Jonathan Reinink">
          <div class="text-sm w-full">
            <p class="text-gray-900 text-base leading-none text-black font-semibold text-data-container-user">
              {{ activeUserInfo.name || '' }}
            </p>
            <p class="text-gray-600 text-xs text-data-container">
              <a>
                {{ activeUserInfo.email || '' }}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="$can('personal_dashboard')" class="my-6 text-center">
      <p class="available-balance-label">
        Available Balance : <span class="font-bold">${{ balance | addComma }}</span>
      </p>
    </div>

    <div v-if="canViewFundBtn" class="text-center">

      <router-link id="sidebar-add-fund-button" to="/fund?ref=SideMenuButton" class="text-center">
      <button @click="$gtag.event('Add_Funds')" class="fund-button">
        <img class="align-middle pl-1 fund-icon" src="@/assets/images/campaign-status/out-of-budget-action-icon.svg"/>
        Add Fund
      </button>
      </router-link>

    </div>

    <hr class="mx-8 my-5 mt-8 divide-gray-speakol">
  </div>

</template>

<script>
import {get} from 'lodash'

export default {
  data () {
    return {
      canViewFundBtn: false
    }
  },
  props: ['activeUserInfo'],
  computed: {
    avatarUrl () {
      const user = this.activeUserInfo

      return this.avatarTempSource || get(user, 'media[0].url', null) || require('@/assets/images/pages/default-avatar.png')
    },
    balance () {
      return this.$store.getters['fund/balance']['balance']
    }
  },
  watch: {
    canViewFundBtn: {
      immediate: true,
      async handler () {
        this.canViewFundBtn = this.$can('add_personal_fund')
      }
    }
  }
}
</script>

<style lang="scss">

.available-balance-label {
  user-select: text;
}
  #user-sidebar-card {
    .divide-gray-speakol {
      border: 1px solid #f1f1f5;
    }

    .square {
      border-radius: 3px;
      padding: 0.679rem 4rem !important;
    }

    .text-data-container {
      width: 140px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      // height: auto;
    }

    .text-data-container-user {
      width: 140px;
      height: 20px;
      // margin-bottom:50px;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .fund-button {
      padding: 10px 55px;
      color: white;
      border-radius: 4px;
      background-color: rgba(var(--vs-primary), 1) !important;
      border: rgba(var(--vs-primary), 1) !important;
      cursor: pointer;
    }

    .fund-icon {
      margin-right: 8px;
    }
  }
</style>
